import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHappenAuth } from '@happen/auth';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHappenAuth({
      apiBaseUrl: environment.apiBaseUrl,
      postLoginUrl: '/app/dashboard',
      appName: 'Happen Business',
      applicationId: 'happen-auth-test-app',
      accessHub: true,
      debugPersistTokensToLocalStorage: true,
    }),
  ],
};
